// // /** @jsx jsx */
// // import React from 'react';
// // import { jsx } from '@emotion/react'
// // import {smallPadding, table, tableCellBorderBottom} from "../styles/tableStyles";
// // import {splitText} from "./titleCaseFunction";
// // import {useCompany} from "../Context/company-context";






// // function CompanyAddress({align="center"}){
// //     const {state} = useCompany();
// //     const { companyName, companyEmail, mobile, address, website, logo } = state;
// //     return (
// //         <table css={[table, smallPadding]}>
// //             {/* <tbody> */}
// //             <tr>
// //                 <td align={align}> <img src={logo ? logo : '/images/mpeke3.png'} style={{width:"120px"}}
// //                                          alt="Mpeke"/></td>
// //             </tr>
// //             <tr>
// //                 <td align={align}><span><strong>{companyName}</strong></span></td>
// //             </tr>
// //             <tr>
// //                 <td align={align}><span>{address ? splitText(address) : address}</span></td>
// //             </tr>
// //             <tr>
// //                 <td align={align}><span>Tel: {mobile}</span></td>
// //             </tr>
// //             {companyEmail ?  <tr>
// //                 <td align={align}><span>Email: {companyEmail}</span></td>
// //             </tr>:null}
// //             {website ?<tr>
// //                 <td align={align} css={[tableCellBorderBottom]}><span>Website: <a href={website} target='_blank'>{website}</a></span></td>
// //             </tr>:null}

// //             {/* </tbody> */}
// //         </table>
// //     );
// // }

// // export default CompanyAddress;


// /** @jsx jsx */
// import React from 'react';
// import { jsx } from '@emotion/react';
// import { smallPadding, table, tableCellBorderBottom } from "../styles/tableStyles";
// import { splitText } from "./titleCaseFunction";
// import { useCompany } from "../Context/company-context";

// function CompanyAddress({ align = "center" }) {
//     const { state } = useCompany();
//     const { companyName, companyEmail, mobile, address, website, logo } = state || {};

//     return (
//         <table css={[table, smallPadding]}>
//             <tbody>
//                 <tr>
//                     <td align={align}>
//                         <img
//                             src={logo || '/images/mpeke3.png'}
//                             onError={(e) => { e.currentTarget.src = '/images/mpeke3.png'; }}
//                             style={{ width: "120px" }}
//                             alt="Company Logo"
//                         />
//                     </td>
//                 </tr>
//                 {companyName && (
//                     <tr>
//                         <td align={align}>
//                             <span><strong>{companyName}</strong></span>
//                         </td>
//                     </tr>
//                 )}
//                 {address && (
//                     <tr>
//                         <td align={align}>
//                             <span>{splitText(address)}</span>
//                         </td>
//                     </tr>
//                 )}
//                 {mobile && (
//                     <tr>
//                         <td align={align}>
//                             <span>Tel: {mobile}</span>
//                         </td>
//                     </tr>
//                 )}
//                 {companyEmail && (
//                     <tr>
//                         <td align={align}>
//                             <span>Email: {companyEmail}</span>
//                         </td>
//                     </tr>
//                 )}
//                 {website && (
//                     <tr>
//                         <td align={align} css={[tableCellBorderBottom]}>
//                             <span>
//                                 Website: <a href={website} target="_blank" rel="noopener noreferrer">{website}</a>
//                             </span>
//                         </td>
//                     </tr>
//                 )}
//             </tbody>
//         </table>
//     );
// }

// export default CompanyAddress;
/** @jsx jsx */
import { jsx } from "@emotion/react";
import React from "react";
// import { useCompany } from "../Context/CompanyContext";
import { useCompany } from "../Context/company-context";

import { table, smallPadding, tableCellBorderBottom } from "../styles/tableStyles";

// Utility to split text into multiple <p> tags with keys
const splitText = (text) => {
  if (!text) return null;
  return text.split("\n").map((line, index) => <p key={index}>{line}</p>);
};

function CompanyAddresslogo({ align = "center" }) {
  const { state } = useCompany();
  const { companyName, companyEmail, mobile, address, website, logo } = state || {};

  const rows = [
    {
      key: "logo",
      content: (
        <img
          src={logo || "/images/mpeke3.png"}
          onError={(e) => {
            e.currentTarget.src = "/images/mpeke3.png";
          }}
          style={{ width: "120px" }}
          alt="Company Logo"
        />
      ),
    },
    { key: "companyName", content: companyName && <strong>{companyName}</strong> },
    { key: "address", content: address && splitText(address) },
    { key: "mobile", content: mobile && `Tel: ${mobile}` },
    { key: "companyEmail", content: companyEmail && `Email: ${companyEmail}` },
    {
      key: "website",
      content: website && (
        <span>
          Website:{" "}
          <a href={website} target="_blank" rel="noopener noreferrer">
            {website}
          </a>
        </span>
      ),
      css: tableCellBorderBottom,
    },
  ];

  return (
    <table css={[table, smallPadding]}>
      <tbody>
        {rows.map((row) =>
          row.content ? (
            <tr key={row.key} css={row.css || undefined}>
              <td align={align}>{row.content}</td>
            </tr>
          ) : null
        )}
      </tbody>
    </table>
  );
}

export default CompanyAddresslogo;
